import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundCustomerPopupCustomerCounterBuyCar,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundCustomerPopupCustomerCounterBuyCar}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop="carleadCreation.form.mainTitle.estimateValue"
      headlineMobile="carleadCreation.form.mainTitle.mobile.estimateValue"
      subheadline="carleadCreation.form.subheadline"
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
